import { render, staticRenderFns } from "./SelectDataType.vue?vue&type=template&id=d66e6468&"
import script from "./SelectDataType.vue?vue&type=script&lang=js&"
export * from "./SelectDataType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports